/* eslint-disable react/function-component-definition */
/* eslint-disable no-use-before-define */
import React from 'react';
import clsx from 'clsx';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { Box, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
// import { AddCircleOutline } from '@mui/icons-material';

const useStyles = makeStyles(() => ({
  root: { marginTop: 22, marginBottom: 22 },
  importButton: {
    marginRight: 10
  },
  exportButton: {
    marginRight: 10
  }
}));

interface ToolbarProps {
  className?: string;
  handleClickOpenSyncWorker: () => void;
}

const ToolbarSyncWorker = ({
  className,
  handleClickOpenSyncWorker,
  ...rest
}: ToolbarProps) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Box display="flex" justifyContent="flex-end">
        <Button
          startIcon={<AutorenewIcon />}
          onClick={handleClickOpenSyncWorker}
          // color="primary"
          style={{
            backgroundColor: '#04862F'
          }}
          variant="contained"
        >
          Sync WorkerSheet
        </Button>
      </Box>
    </div>
  );
};

export default ToolbarSyncWorker;
